module.exports = __webpack_public_path__ + "img/ys-sixteen-grid-select.d2fe96b3.png";